<iframe
  #pdfIframe
  id="pdf-js-viewer"
  width="100%"
  height="100%"
  frameBorder="0"
  allowfullscreen="true">
</iframe>
